<template>
  <v-app>
    <v-app-bar
      app
      flat
      fixed
    >
      <div class="d-flex align-center logo-wrap">
        <Logo />
      </div>

      <v-spacer></v-spacer>

    </v-app-bar>

      <!-- Contact BTN -->
      <div class="btn-wrap">
        <v-btn
          color="transparent"
          width="50"
          class="btn-mail"
          fixed
          icon
          rippel="false"
          @click="$vuetify.goTo(scrollTarget, scrollOptions)"
        >

          <img
          src="/images/email_icon_neu_header.png"
          alt="kontakt-btn" width="50" class="kontakt-scroll-btn">
        </v-btn>

        <v-btn
          color="transparent"
          class="btn-tel"
          width="50"
          fixed
          icon
          rippel="false"
          @click="$vuetify.goTo(scrollTarget, scrollOptions)"
        >

          <img
          src="/images/atelier_calltoaction_button_telefon.png"
          alt="kontakt-btn" width="50" class="kontakt-scroll-btn">
        </v-btn>
    </div>

    <v-content class="pa-0">
      <Intro/>

      <CustomSection
        title="Neukunden-Kontakte schaffen"
        class="first-section bg-grey"
        :cols="neukunden"
        id="neukunden"
      />
      <CustomSection
        title="Produkte und Leistungen präsentieren"
        class="bg-white"
        :cols="produkte"
        id="produkte"
      />
      <CustomSection
        title="Aufträge gewinnen"
        class="bg-grey"
        :cols="auftraege"
        id="auftraege"
      />
      <CustomSection
        title="Umsatz generieren"
        class="bg-white"
        :cols="umsatz"
        id="umsatz"
      />
      <CustomSection
        title="Kontakte intensivieren"
        class="bg-grey"
        :cols="kontakt"
        id="kontakt-halten"
      />
      <UnsereKunden
        title="<span>Unsere Kunden</span>"
        class="bg-white"
        id="unsere-kunden"
      />
      <Aha />
      <Kontakt id="aha" />
      <Footer />
    </v-content>
  </v-app>
</template>

<script>
import Logo from './components/Logo.vue';
import Intro from './components/Intro.vue';
import CustomSection from './components/CustomSection.vue';
import Aha from './components/Aha.vue';
import Footer from './components/Footer.vue';
import UnsereKunden from './components/UnsereKunden.vue';
import Kontakt from './components/Kontakt.vue';

export default {
  name: 'App',

  components: {
    Logo,
    Intro,
    CustomSection,
    Aha,
    Footer,
    UnsereKunden,
    Kontakt,
  },

  data: () => ({
    scrollOptions: {
      duration: 750,
      offset: 0,
      easing: 'easeInOutCubic',
    },
    scrollTarget: '#aha',

    neukunden: [
      {
        html: '<strong>Landing Pages,</strong><br>die aus Leads Kunden machen',
        img: '/images/atelier_neukundenkontakt_landing_page.png',
        lazy: '/images/lazy/atelier_neukundenkontakt_landing_page.png',
      },
      {
        html: '<strong>SEO / SEA / Adwords-Kampagnen</strong>,<br>(Werbung in Suchmaschinen)',
        img: '/images/atelier_neukundenkontakt_SEO_SEA_Adwords.png',
        lazy: '/images/lazy/atelier_neukundenkontakt_SEO_SEA_Adwords.png',
      },
      {
        html: '<strong>Werbung<br>in Social Media</strong>',
        img: '/images/atelier_neukundenkontakt_werbung_in_social_media.png',
        lazy: '/images/lazy/atelier_neukundenkontakt_werbung_in_social_media.png',
      },
    ],
    produkte: [
      {
        html: '<strong>Digitale Messestände<br> und Showrooms</strong>',
        img: '/images/atelier_produkte_leistungen_praesentieren_digitale_showroom.png',
        lazy: '/images/lazy/atelier_produkte_leistungen_praesentieren_digitale_showroom.png',
      },
      {
        html: '<strong>Tutorials und Produktfilme</strong><br> (Bewegtbild-Unterstützung)',
        img: '/images/atelier_produkte_leistungen_praesentieren_tutorial_produktfilm.png',
        lazy: '/images/lazy/atelier_produkte_leistungen_praesentieren_tutorial_produktfilm.png',
      },
      {
        html: '<strong>Livestreams zu</strong><br> Produkteinführung und Präsentation</strong>',
        img: '/images/atelier_produkte_leistungen_praesentieren_livestreams.png',
        lazy: '/images/lazy/atelier_produkte_leistungen_praesentieren_livestreams.png',
      },
    ],
    auftraege: [
      {
        html: '<strong>Webinare</strong><br>statt Seminare',
        img: '/images/atelier_auftraege_gewinnen_webinare.png',
        lazy: '/images/lazy/atelier_auftraege_gewinnen_webinare.png',
      },
      {
        html: '<strong>Integration von Chat-Funktionen</strong><br> auf Webseiten',
        img: '/images/atelier_auftraege_gewinnen_integration_chatfunktion.png',
        lazy: '/images/lazy/atelier_auftraege_gewinnen_integration_chatfunktion.png',
      },
      {
        html: '<strong>Kundenberatung<br> über FaceTime</strong>',
        img: '/images/atelier_auftraege_gewinnen_kundenberatung_via_facetime.png',
        lazy: '/images/lazy/atelier_auftraege_gewinnen_kundenberatung_via_facetime.png',
      },
    ],
    umsatz: [
      {
        html: '<strong>Conversion-optimierte<br> Web-Promotion</strong>',
        img: '/images/atelier_umsatz_generieren_conversion_optimierte_webpromotion.png',
        lazy: '/images/lazy/atelier_umsatz_generieren_conversion_optimierte_webpromotion.png',
      },
      {
        html: '<strong>Online-Shops</strong><br class="d-none d-md-block">&nbsp;',
        img: '/images/atelier_umsatz_generieren_onlineshop.png',
        lazy: '/images/lazy/atelier_umsatz_generieren_onlineshop.png',
      },
      {
        html: 'Einfache <strong>Bestellformulare</strong><br class="d-none d-md-block">&nbsp;',
        img: '/images/atelier_umsatz_generieren_bestellformulare.png',
        lazy: '/images/lazy/atelier_umsatz_generieren_bestellformulare.png',
      },
    ],
    kontakt: [
      {
        html: '<strong>Livestreams, Chats<br> und Videokonferenzen</strong>',
        img: '/images/atelier_kundenkontakt_halten_livestream_chat_videokonferenz.png',
        lazy: '/images/lazy/atelier_kundenkontakt_halten_livestream_chat_videokonferenz.png',
      },
      {
        html: '<strong>Relevanter Content<br> auf Social Media</strong>',
        img: '/images/atelier_kundenkontakt_halten_content_auf_social_media.png',
        lazy: '/images/lazy/atelier_kundenkontakt_halten_content_auf_social_media.png',
      },
      {
        html: '<strong>Newsletter</strong><br class="d-none d-md-block">&nbsp;',
        img: '/images/atelier_kundenkontakt_halten_newsletter.png',
        lazy: '/images/lazy/atelier_kundenkontakt_halten_newsletter.png',
      },
    ],
  }),
  methods: {
    onResize() {
      if (window.innerHeight < 800 || window.innerWidth < 960) {
        document.getElementById('neukunden').classList.remove('first-section');
        document.getElementById('parallax').classList.remove('pos-fixed');
      }
      if (window.innerHeight >= 799 || window.innerWidth >= 960) {
        document.getElementById('neukunden').classList.add('first-section');
        document.getElementById('parallax').classList.add('pos-fixed');
      }
    },
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
};
</script>
<style lang="scss">
  #progress-el {
    background-color: #f53645 !important;
  }

  .theme--light.v-app-bar.v-toolbar.v-sheet {
    z-index: 99999;
    background-color: transparent !important;
  }

  body,
  html {
    background-color: white;
  }

  .bg-white {
    background-color: white;
  }

  .logo-wrap {
    margin-top: 77px;
    margin-left: 4%;
  }

  .content {
    position: relative;
    z-index: 9;
  }

  .btn-wrap {
    position: fixed;
    z-index: 99999999;
  }

  .btn-mail {
    top: 50px;
    right: 4vw;
  }

  .btn-tel {
    top: 118px;
    right: 4vw;
  }

  h2 {
    font-family: 'ff-market-web', sans-serif;
    color: #243236;
    font-size: 2.895rem;
    font-weight: 300;
    line-height: 1.11 !important;
    margin: 3.842rem 0 3.421rem 0;
  }

  .sidebar-nav {
    position: fixed;
    width: 3px;
    right: 4vw;
    width: 23px;
    top: 45vh;
    z-index: -1;
    opacity: 0;
    transition: all .3s ease;

    &.side-nav-active {
      opacity: 1;
      z-index: 9999;
    }

    .menu-item {
      display: block;
      background-color: #243236;
      width: 3px;
      height: 25px;
      margin-bottom: 10px;
      z-index: 9;

      &:hover {
        cursor: pointer;
      }

      &.side-active {
        background-color: #f53645
      }
    }
  }

  @media screen and (max-width: 1904px) {
    html,
    body {
      font-size: 16px !important;
    }
  }

  @media screen and (max-width: 960px) {
    h2 {
      font-size: 1.75rem;
    }
  }

  @media screen and (max-width: 960px) {
      .kontakt-scroll-btn {
        width: 35px !important;
      }

      .logo-wrap {
        margin-top: 15px;
        margin-left: 1%;
      }

      .btn-mail {
        top: 15px;
      }

      .btn-tel {
        top: 60px;
      }
  }

  @media screen and (max-width: 512px) {
    html,
    body {
      font-size: 14px !important;
    }

    h2 {
      font-size: 1.5rem;
    }
  }

</style>
